jQuery(document).ready(function($){

    $('.is-accordion-submenu-parent > a').click(function(){
        if ($(this).attr('href') != '#') {
            $(this).unbind('click');
        }
    });

});
